import React, { useEffect } from 'react';
import { apis } from '../../services/Api';
import { setToken } from '../../services/Auth';

function SignInEnd(props) {

    useEffect(() => {
        let hashParams = getHashParameters();
        // //console.log(hashParams);
        if (hashParams["error"]) {

        } else if (hashParams["code"]) {
            //console.log(hashParams["code"]);
            apis.getToken(hashParams["code"]).then((result) => {
                //console.log(result);
                setToken(result);
                props.history.push({
                    pathname: "/"
                });
            }).catch((e) => {
                //console.log(e);
            })
        } else {
            // Unexpected condition: hash does not contain error or access_token parameter
        }
    }, []);

    return (<></>);
}

// Parse hash parameters into key-value pairs
export function getHashParameters() {
    var search = window.location.search.substring(1);
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export default SignInEnd;